<template>
  <div class="search-result">
    <div class="content">
      <div class="header">
        <div class="search-wrapper">
          <div style="display: flex; align-items: center">
            <img src="@/assets/img/home_mini.png" alt="" />
            <span class="title">工程造价咨询企业公共服务查询</span>
          </div>
          <div style="display: flex; align-items: center">
            <input
              type="text"
              v-model="form.name"
              placeholder="请输入企业名称"
            />
            <!--            <input-->
            <!--              type="text"-->
            <!--              v-model="form.code"-->
            <!--              placeholder="请输入统一社会信用代码证号"-->
            <!--            />-->
            <div class="search-btn" @click="detail()">查询</div>
          </div>
        </div>
      </div>
      <div class="detail-panel">
        <div class="base-info">
          <div class="title">企业基本信息</div>
          <div class="base-content">
            <ul class="line">
              <li>
                企业名称：<span>{{ details.name ? details.name : "--" }}</span>
              </li>
              <li>
                企业经济类型：<span
                  >{{ details.eco_type ? details.eco_type : "--" }}
                </span>
              </li>
              <li>
                法定代表人：<span>{{
                  details.legal_name ? details.legal_name : "--"
                }}</span>
              </li>
            </ul>
            <ul class="line">
              <li>
                企业地址：<span>{{ details.address }}</span>
              </li>
              <li>
                企业社会统一信用代码证号：<span>{{
                  details.code ? details.code : "--"
                }}</span>
              </li>
              <li>
                成立日期：<span>{{
                  details.com_create_time ? details.com_create_time : "--"
                }}</span>
              </li>
            </ul>
          </div>
          <div class="user-info">
            <div class="title">企业人员信息</div>
            <div class="table-wrapper">
              <p>一级注册造价工程师（{{ level1.count }}人）</p>
              <el-table :data="tableData1" class="tableControll">
                <el-table-column
                  style="margin-left: 30px"
                  type="index"
                  label="序号"
                  align="center"
                  min-width="30%"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  min-width="50%"
                >
                </el-table-column>
                <el-table-column
                  prop="cert_number"
                  align="center"
                  label="注册证书编号"
                >
                </el-table-column>
              </el-table>
              <p class="second">二级注册造价工程师（{{ level2.count }}人）</p>
              <el-table :data="tableData2" class="tableControll">
                <el-table-column
                  style="margin-left: 30px"
                  type="index"
                  label="序号"
                  align="center"
                  min-width="30%"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  min-width="50%"
                >
                </el-table-column>
                <el-table-column
                  prop="cert_number"
                  align="center"
                  label="注册证书编号"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="user-info" style="margin-top: unset">
            <div class="title">业绩信息</div>
            <div v-if="performance && performance.length" class="yj-controll">
              <div class="yj" v-for="(item, index) in performance" :key="index">
                <div class="money-t">
                  {{ item.year }}年度工程造价营业收入(万)
                </div>
                <div class="money">
                  ￥<span>{{ item.project_income }}</span>
                </div>
              </div>
            </div>
            <div v-else class="emptyT">暂无信息</div>
          </div>
          <div class="user-info" style="margin-top: unset">
            <div class="title">不良行为记录</div>
            <div class="record" v-for="(item, index) in bad" :key="index">
              {{ item.content }}
              <a v-if="item.file" :href="item.file" target="_blank">查看文件</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <foot-home></foot-home>-->
  </div>
</template>

<script>
// import NavHeader from "@/components/NavHeader.vue";
// import FootHome from "@/components/FootHome.vue";
// import { resultDetails } from "@/api/index.js";

import { search } from "@/api";

export default {
  name: "result",
  data() {
    return {
      details: {}, // 总详情
      performance: [], //业绩信息
      bad: [], //不良行为记录
      level2: {}, //二级造价工程师
      level1: {}, //一级造价工程师
      tableData2: [], //二级造价工程师 人员表格
      tableData1: [], //一级造价工程师 人员表格

      companyId: "", //公司id
      form: {
        name: "", // 公司名称
        // code: "", // 公司统一社会信用代码
      },
      social_code: "", // 统一社会信用代码
      company: "",
      firstNum: "",
      secondNum: "",
      first: [],
      second: [],
    };
  },
  created() {
    this.form.name = this.$route.query.name;
    // this.form.code = this.$route.query.code;
    this.detail();
  },
  mounted() {},
  methods: {
    async detail() {
      const details = await search(this.form);
      this.details = details;
      this.performance = details.performance;
      this.bad = details.bad;
      this.level2 = details.staff.level2;
      this.level1 = details.staff.level1;
      this.tableData1 = details.staff.level1.list;
      this.tableData2 = details.staff.level2.list;
    },
  },
};
</script>

<style lang="less" scoped>
.titleSty() {
  height: 22px;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  border-left: 4px solid #4379f6;
  padding-left: 16px;
}

.content {
  .header {
    display: flex;
    align-items: center;
    height: 100px;
    background: #ffffff;

    .search-wrapper {
      display: flex;
      align-items: center;
      margin: auto;
      width: 1200px;
      justify-content: space-between;

      img {
        width: 22px;
        height: 22px;
      }

      .title {
        font-size: 20px;
        color: #333333;
        margin-right: 20px;
        margin-left: 6px;
      }

      *::-webkit-input-placeholder {
        color: #cfcfcf;
      }

      input {
        outline: none;
        border: none;
        width: 370px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #e3e3e3;
        border-radius: 2px;
        padding: 8px 10px;
        color: #333333;
        margin-right: 10px;
        box-sizing: border-box;

        &:focus,
        &:hover {
          box-shadow: 0px 0px 5px 0px rgba(67, 121, 246, 0.35);
          border: 1px solid #4379f6;
        }
      }

      .search-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 36px;
        background: #4379f6;
        border-radius: 2px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;

        &:hover {
          transition: all 1s;
          background: #3870f1;
        }
      }
    }
  }

  .detail-panel {
    margin-top: 20px;
    padding: 30px 0px;
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    background: #ffffff;

    .base-info {
      .title {
        .titleSty();
        display: flex;
      }

      .base-content {
        margin-top: 20px;
        padding: 0px 20px;

        & > :nth-child(2) {
          margin-top: 20px;
        }

        .line {
          display: flex;

          > li {
            text-align: left;
            color: #333;
            list-style-type: none;
            margin-left: 30px;
            font-size: 14px;

            &:first-child {
              margin-left: unset;
            }

            span {
              color: #333;
            }
          }

          > li:nth-child(1),
          > li:nth-child(2) {
            flex: 2;
          }

          > li:nth-child(3) {
            flex: 1;
          }
        }
      }
    }

    .user-info {
      margin-top: 43px;
      padding-bottom: 52px;

      .title {
        .titleSty();
        margin-bottom: 20px;
      }

      .emptyT {
        font-size: 14px;
        margin: 20px 0 0 20px;
        color: #333333;
      }

      .yj-controll {
        margin: 20px 20px 0px;
        display: flex;
        align-items: center;

        .yj {
          width: calc((100% - 40px) / 3);
          height: 76px;
          background: #f5f5f5;
          border-radius: 2px;
          padding: 16px 25px;
          box-sizing: border-box;
          margin-left: 24px;

          &:first-child {
            margin-left: unset;
          }

          .money-t {
            font-size: 12px;
            color: #666666;
            text-align: left;
          }

          .money {
            display: flex;
            align-items: center;
            margin-top: 2px;

            span {
              font-size: 20px;
              color: #333333;
              font-family: "BEBAS";
              font-weight: bold;
            }
          }
        }
      }

      .record {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333333;
        margin-top: 20px;
        margin-left: 21px;

        a {
          font-size: 12px;
          color: #4379f6;
          margin-left: 10px;
        }
      }

      .table-wrapper {
        padding: 0px 20px;

        p {
          margin-bottom: 14px;
          text-align: left;
        }

        .second {
          margin-top: 26px;
        }

        .tableControll {
          width: 100%;
          border: solid 1px rgb(235, 238, 245);
          border-bottom: unset;
        }

        /deep/ .el-table th {
          background: #f6f6f6 !important;
          color: #666;
          font-weight: normal;
        }

        /deep/ .el-table tr {
          color: #333 !important;
          font-size: 12px;
        }

        /deep/ .el-table__empty-text {
          line-height: unset;
        }
      }
    }
  }
}
</style>
